import React from 'react';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import { Button } from '@mui/material';

interface SnackbarProps {
    children?: React.ReactElement<any, any> & React.ReactNode;
}

const DismissButton: React.FC<{ snackbarKey: string | number }> = ({ snackbarKey }) => {
    const handleClick = React.useCallback(() => {
        closeSnackbar(snackbarKey);
    }, [snackbarKey]);
    return (
        <Button color="inherit" onClick={handleClick}>
            Dismiss
        </Button>
    );
};

export const SnackbarProviderWrapper: React.FC<SnackbarProps> = ({ children }) => {
    const buttonDismissNotification = React.useCallback(
        (key: string | number) => <DismissButton snackbarKey={key} />,
        []
    );

    return (
        <SnackbarProvider
            action={buttonDismissNotification}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
        >
            {children}
        </SnackbarProvider>
    );
};
